export default "__VITE_PUBLIC_ASSET__68409db7__"